import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted} from 'vue';
import useCollaboratorState from '@/app/collaborator/infrastructure/persistence/CollaboratorState';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCollaborator',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const state = useCollaboratorState();



const collaboratorOptions = ref<any[]>([]);

onMounted(async () => {
    collaboratorOptions.value = await state.getAllSimple();
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": __props.modelValue,
    label: "Colaborador",
    "item-title": "name",
    "item-value": "id",
    items: collaboratorOptions.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["model-value", "items"]))
}
}

})